import danfo from "./../assets/popularTrips/danfoBus.png";
import buses from "./../assets/popularTrips/buses.png";
import napep from "./../assets/popularTrips/napep.png";
import star from './../assets/popularTrips/star.png';

const Images = {
  danfo,
  buses,
  napep,
  star
};

export default Images;
